import { isNil } from 'lodash';

export const isCallableFuntion = (maybeFn: unknown): maybeFn is CallableFunction => {
  if (isNil(maybeFn)) return false;

  return typeof maybeFn === 'function';
};
